(function () {
  'use strict';

  var activeSheet = null;
  var activeSheetTrigger = null;
  var customFilterNames = ['ds_type', 'ds_origin', 'ds_sale', 'ds_new'];

  function currentUrl() {
    return new URL(window.location.href);
  }

  function hasCustomFilters() {
    var params = currentUrl().searchParams;
    return customFilterNames.some(function (name) {
      return params.has(name);
    });
  }

  function removeParamValue(params, name, value) {
    var retained = params.getAll(name).filter(function (candidate) {
      return candidate !== value;
    });
    params.delete(name);
    retained.forEach(function (candidate) {
      params.append(name, candidate);
    });
  }

  function productsHash(section) {
    return '#CollectionProducts-' + section.dataset.sectionId;
  }

  function hydrateCustomInputs(section) {
    var params = currentUrl().searchParams;

    section.querySelectorAll('[data-collection-custom-option]').forEach(function (input) {
      input.checked = params.getAll(input.name).indexOf(input.value) !== -1;
      if (input.checked) {
        var group = input.closest('[data-collection-filter-group]');
        if (group) group.open = true;
      }
    });
  }

  function preserveCustomParams(form) {
    form.querySelectorAll('[data-collection-preserved-custom]').forEach(function (input) {
      input.remove();
    });

    var params = currentUrl().searchParams;
    customFilterNames.forEach(function (name) {
      params.getAll(name).forEach(function (value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        input.dataset.collectionPreservedCustom = 'true';
        form.appendChild(input);
      });
    });
  }

  function prepareForm(form) {
    form.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.disabled = input.value.trim() === '';
    });
    form.querySelectorAll('[data-collection-price-range]').forEach(function (input) {
      input.disabled = Number(input.value) >= Number(input.max);
    });
  }

  function submitForm(form) {
    if (form.matches('[data-collection-sort-form], [data-collection-mobile-sort-form]')) {
      preserveCustomParams(form);
    }
    prepareForm(form);
    HTMLFormElement.prototype.submit.call(form);
  }

  function initSort(form) {
    if (form.dataset.collectionSortInitialized === 'true') return;
    form.dataset.collectionSortInitialized = 'true';

    var select = form.querySelector('[data-collection-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      submitForm(form);
    });
  }

  function initFilterForm(form) {
    if (form.dataset.collectionFilterInitialized === 'true') return;
    form.dataset.collectionFilterInitialized = 'true';

    form.addEventListener('submit', function () {
      prepareForm(form);
    });

    form.querySelectorAll('[data-collection-price-range]').forEach(function (input) {
      var output = input.parentElement.querySelector('[data-collection-price-value]');
      if (!output) return;
      input.addEventListener('input', function () {
        output.textContent = input.value + ' ' + input.dataset.currencySymbol;
      });
    });

    if (form.dataset.collectionFilterMode !== 'desktop') return;

    form.addEventListener('change', function (event) {
      if (!event.target.matches('input[type="checkbox"], [data-collection-price-range]')) return;
      submitForm(form);
    });
  }

  function focusableElements(panel) {
    return Array.prototype.slice.call(panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function closeSheet(restoreFocus) {
    if (!activeSheet) return;

    activeSheet.hidden = true;
    document.body.classList.remove('collection-sheet-open');
    if (activeSheetTrigger) activeSheetTrigger.setAttribute('aria-expanded', 'false');

    var trigger = activeSheetTrigger;
    activeSheet = null;
    activeSheetTrigger = null;

    if (restoreFocus !== false && trigger && document.contains(trigger)) {
      trigger.focus();
    }
  }

  function openSheet(sheet, trigger) {
    if (!sheet) return;
    if (activeSheet && activeSheet !== sheet) closeSheet(false);

    activeSheet = sheet;
    activeSheetTrigger = trigger;
    sheet.hidden = false;
    document.body.classList.add('collection-sheet-open');
    trigger.setAttribute('aria-expanded', 'true');

    window.requestAnimationFrame(function () {
      var panel = sheet.querySelector('[data-collection-sheet-panel]');
      if (panel) panel.focus();
    });
  }

  function initSheet(sheet) {
    if (sheet.dataset.collectionSheetInitialized === 'true') return;
    sheet.dataset.collectionSheetInitialized = 'true';

    sheet.querySelectorAll('[data-collection-sheet-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        closeSheet(true);
      });
    });

    sheet.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeSheet(true);
        return;
      }
      if (event.key !== 'Tab') return;

      var panel = sheet.querySelector('[data-collection-sheet-panel]');
      var focusable = panel ? focusableElements(panel) : [];
      if (!focusable.length) {
        event.preventDefault();
        if (panel) panel.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function initSheetTriggers(root) {
    root.querySelectorAll('[data-collection-sheet-open]').forEach(function (trigger) {
      if (trigger.dataset.collectionSheetTriggerInitialized === 'true') return;
      trigger.dataset.collectionSheetTriggerInitialized = 'true';
      trigger.setAttribute('aria-expanded', 'false');

      trigger.addEventListener('click', function () {
        var section = trigger.closest('[data-collection-page]');
        var sheetName = trigger.dataset.collectionSheetOpen;
        var sheet = section && section.querySelector('[data-collection-sheet="' + sheetName + '"]');
        openSheet(sheet, trigger);
      });
    });
  }

  function initMobileSort(form) {
    if (form.dataset.collectionMobileSortInitialized === 'true') return;
    form.dataset.collectionMobileSortInitialized = 'true';

    form.addEventListener('change', function (event) {
      if (!event.target.matches('input[type="radio"][name="sort_by"]')) return;
      submitForm(form);
    });
  }

  function initDescription(disclosure) {
    if (disclosure.dataset.collectionDescriptionInitialized === 'true') return;
    disclosure.dataset.collectionDescriptionInitialized = 'true';

    var content = disclosure.querySelector('[data-collection-description-content]');
    var toggle = disclosure.querySelector('[data-collection-description-toggle]');
    if (!content || !toggle || content.scrollHeight <= content.clientHeight + 1) return;

    toggle.hidden = false;
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      content.classList.toggle('is-expanded', !expanded);
      toggle.setAttribute('aria-expanded', String(!expanded));
      toggle.textContent = expanded ? toggle.dataset.moreLabel : toggle.dataset.lessLabel;
    });
  }

  function renderCustomFilterChips(section) {
    var container = section.querySelector('[data-collection-active-filters]');
    var rail = section.querySelector('[data-collection-active-filter-rail]');
    var clear = section.querySelector('[data-collection-clear-filters]');
    var activeCount = section.querySelector('[data-collection-active-count]');
    if (!container || !rail || !clear) return;

    rail.querySelectorAll('[data-collection-custom-chip]').forEach(function (chip) {
      chip.remove();
    });

    var params = currentUrl().searchParams;
    var customCount = 0;

    customFilterNames.forEach(function (name) {
      params.getAll(name).forEach(function (value) {
        var source = Array.prototype.find.call(
          section.querySelectorAll('[data-collection-custom-option]'),
          function (input) {
            return input.name === name && input.value === value;
          }
        );
        if (!source) return;

        var removeUrl = currentUrl();
        removeParamValue(removeUrl.searchParams, name, value);
        removeUrl.searchParams.delete('ds_page');
        removeUrl.searchParams.delete('page');
        removeUrl.hash = productsHash(section);

        var chip = document.createElement('a');
        chip.className = 'collection-active-filters__chip';
        chip.href = removeUrl.toString();
        chip.dataset.collectionCustomChip = 'true';

        var label = document.createElement('span');
        label.textContent = source.dataset.filterLabel || value;
        chip.appendChild(label);

        var remove = document.createElement('span');
        remove.className = 'collection-active-filters__remove';
        remove.setAttribute('aria-hidden', 'true');
        remove.innerHTML = '<svg viewBox="0 0 12 12"><path d="m2 2 8 8M10 2 2 10"></path></svg>';
        chip.appendChild(remove);

        clear.parentNode.insertBefore(chip, clear);
        customCount += 1;
      });
    });

    var nativeCount = rail.querySelectorAll('[data-collection-native-chip]').length;
    var total = nativeCount + customCount;
    container.hidden = total === 0;
    if (activeCount) {
      activeCount.textContent = String(total);
      activeCount.hidden = total === 0;
    }
  }

  function selectedMatchValues(section, name) {
    var selected = currentUrl().searchParams.getAll(name);
    var matches = [];

    section.querySelectorAll('[data-collection-custom-option]').forEach(function (input) {
      if (input.name !== name || selected.indexOf(input.value) === -1) return;
      (input.dataset.filterValues || input.value).split('|').forEach(function (value) {
        if (matches.indexOf(value) === -1) matches.push(value);
      });
    });

    return matches;
  }

  function maximumServerPage(section) {
    var maximum = 1;
    section.querySelectorAll('[data-collection-pagination] .collection-pagination__item').forEach(function (item) {
      var page = Number(item.textContent.trim());
      if (Number.isFinite(page)) maximum = Math.max(maximum, page);
    });
    return maximum;
  }

  function fetchServerPage(section, page, signal) {
    var url = currentUrl();
    url.searchParams.delete('ds_page');
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', section.dataset.sectionId);
    url.hash = '';

    return fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Collection page request failed');
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var renderedSection = parsed.querySelector(
          '[data-collection-products][data-section-id="' + section.dataset.sectionId + '"]'
        );
        if (!renderedSection) throw new Error('Collection section was not returned');
        return Array.prototype.map.call(
          renderedSection.querySelectorAll('[data-collection-filter-item]'),
          function (item) {
            return item.outerHTML;
          }
        );
      });
  }

  function itemMatchesComputedFilters(item, typeValues, originValues, saleOnly, newOnly) {
    if (typeValues.length && typeValues.indexOf(item.dataset.collectionType) === -1) return false;
    if (originValues.length && originValues.indexOf(item.dataset.collectionOrigin) === -1) return false;
    if (saleOnly && item.dataset.collectionOnSale !== 'true') return false;

    if (newOnly && item.dataset.collectionIsFresh !== 'true') return false;

    return true;
  }

  function ensureProductGrid(section) {
    var grid = section.querySelector('[data-collection-product-grid]');
    if (grid) return grid;

    grid = document.createElement('ul');
    grid.className = 'collection-products-v1__grid';
    grid.setAttribute('role', 'list');
    grid.dataset.collectionProductGrid = 'true';

    var empty = section.querySelector('.collection-products-v1__empty');
    if (empty) empty.parentNode.insertBefore(grid, empty);
    return grid;
  }

  function removeSectionQuickViews(sectionId) {
    var prefix = 'QuickView-premium-' + sectionId + '-';
    document.querySelectorAll('[data-product-quick-view]').forEach(function (dialog) {
      if (dialog.id.indexOf(prefix) === 0) dialog.remove();
    });
  }

  function pageLink(section, page) {
    var url = currentUrl();
    url.searchParams.delete('page');
    if (page <= 1) {
      url.searchParams.delete('ds_page');
    } else {
      url.searchParams.set('ds_page', String(page));
    }
    url.hash = productsHash(section);
    return url.toString();
  }

  function appendPaginationItem(list, child) {
    var item = document.createElement('li');
    item.appendChild(child);
    list.appendChild(item);
  }

  function renderClientPagination(section, totalPages, currentPage) {
    var nav = section.querySelector('[data-collection-pagination]');

    if (totalPages <= 1) {
      if (nav) nav.hidden = true;
      return;
    }

    if (!nav) {
      nav = document.createElement('nav');
      nav.className = 'collection-pagination';
      nav.dataset.collectionPagination = 'true';
      nav.setAttribute('aria-label', section.dataset.paginationLabel || 'Pagination');
      var empty = section.querySelector('[data-collection-client-empty]');
      if (empty) empty.parentNode.insertBefore(nav, empty);
    }

    nav.hidden = false;
    nav.innerHTML = '';
    var list = document.createElement('ul');
    list.className = 'collection-pagination__list';
    list.setAttribute('role', 'list');

    if (currentPage > 1) {
      var previous = document.createElement('a');
      previous.className = 'collection-pagination__item collection-pagination__item--arrow';
      previous.href = pageLink(section, currentPage - 1);
      previous.setAttribute('aria-label', section.dataset.paginationPrevious || 'Previous');
      previous.innerHTML = '<span aria-hidden="true">‹</span>';
      appendPaginationItem(list, previous);
    }

    for (var page = 1; page <= totalPages; page += 1) {
      var pageElement;
      if (page === currentPage) {
        pageElement = document.createElement('span');
        pageElement.className = 'collection-pagination__item collection-pagination__item--current';
        pageElement.setAttribute('aria-current', 'page');
      } else {
        pageElement = document.createElement('a');
        pageElement.className = 'collection-pagination__item';
        pageElement.href = pageLink(section, page);
      }
      pageElement.setAttribute(
        'aria-label',
        (section.dataset.paginationPage || 'Page __NUMBER__').replace('__NUMBER__', String(page))
      );
      pageElement.textContent = String(page);
      appendPaginationItem(list, pageElement);
    }

    if (currentPage < totalPages) {
      var next = document.createElement('a');
      next.className = 'collection-pagination__item collection-pagination__item--arrow';
      next.href = pageLink(section, currentPage + 1);
      next.setAttribute('aria-label', section.dataset.paginationNext || 'Next');
      next.innerHTML = '<span aria-hidden="true">›</span>';
      appendPaginationItem(list, next);
    }

    nav.appendChild(list);
  }

  function renderComputedProducts(section, itemMarkup) {
    var template = document.createElement('template');
    var typeValues = selectedMatchValues(section, 'ds_type');
    var originValues = selectedMatchValues(section, 'ds_origin');
    var params = currentUrl().searchParams;
    var saleOnly = params.get('ds_sale') === '1';
    var newOnly = params.get('ds_new') === '1';

    var matches = itemMarkup.filter(function (markup) {
      template.innerHTML = markup;
      var item = template.content.firstElementChild;
      return item && itemMatchesComputedFilters(item, typeValues, originValues, saleOnly, newOnly);
    });

    var perPage = Math.max(1, Number(section.dataset.productsPerPage) || 24);
    var totalPages = Math.max(1, Math.ceil(matches.length / perPage));
    var requestedPage = Math.max(1, Number(params.get('ds_page')) || 1);
    var currentPage = Math.min(requestedPage, totalPages);
    var start = (currentPage - 1) * perPage;
    var visibleMarkup = matches.slice(start, start + perPage);
    var grid = ensureProductGrid(section);
    var count = section.querySelector('[data-collection-product-count]');
    var clientEmpty = section.querySelector('[data-collection-client-empty]');
    var serverEmpty = section.querySelector('.collection-products-v1__empty:not([data-collection-client-empty])');

    removeSectionQuickViews(section.dataset.sectionId);
    grid.innerHTML = visibleMarkup.join('');
    grid.hidden = matches.length === 0;
    grid.removeAttribute('aria-busy');
    if (count) count.textContent = String(matches.length);
    section.querySelectorAll('[data-collection-filter-submit]').forEach(function (button) {
      button.textContent = (button.dataset.labelTemplate || 'Show __COUNT__').replace(
        '__COUNT__',
        String(matches.length)
      );
    });
    if (serverEmpty) serverEmpty.hidden = true;
    if (clientEmpty) clientEmpty.hidden = matches.length !== 0;

    renderClientPagination(section, matches.length ? totalPages : 0, currentPage);

    if (window.ProductCardPremium && typeof window.ProductCardPremium.init === 'function') {
      window.ProductCardPremium.init(grid);
    }
  }

  function initComputedFilters(section) {
    if (!hasCustomFilters()) return;

    if (section._collectionComputedAbort) section._collectionComputedAbort.abort();
    var controller = new AbortController();
    section._collectionComputedAbort = controller;

    var grid = ensureProductGrid(section);
    grid.setAttribute('aria-busy', 'true');
    var totalPages = maximumServerPage(section);
    var requests = [];
    for (var page = 1; page <= totalPages; page += 1) {
      requests.push(fetchServerPage(section, page, controller.signal));
    }

    Promise.all(requests)
      .then(function (pages) {
        if (controller.signal.aborted) return;
        renderComputedProducts(section, Array.prototype.concat.apply([], pages));
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') {
          grid.removeAttribute('aria-busy');
          window.console.warn('[collection-system] Computed filters failed', error);
        }
      });
  }

  function initFilterJump(section) {
    if (section._collectionJumpCleanup) section._collectionJumpCleanup();

    var wrapper = section.querySelector('[data-collection-filter-jump]');
    var button = section.querySelector('[data-collection-filter-jump-button]');
    var sidebar = section.querySelector('.collection-products-v1__sidebar');
    if (!wrapper || !button || !sidebar) return;

    var desktop = window.matchMedia('(min-width: 990px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var frame = null;

    function update() {
      frame = null;
      wrapper.hidden = !desktop.matches || sidebar.getBoundingClientRect().top <= window.innerHeight * 0.5;
    }

    function scheduleUpdate() {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    }

    function scrollToFilters() {
      sidebar.scrollIntoView({
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
        block: 'start'
      });
    }

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    desktop.addEventListener('change', scheduleUpdate);
    button.addEventListener('click', scrollToFilters);
    update();

    section._collectionJumpCleanup = function () {
      window.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      desktop.removeEventListener('change', scheduleUpdate);
      button.removeEventListener('click', scrollToFilters);
      if (frame) window.cancelAnimationFrame(frame);
      section._collectionJumpCleanup = null;
    };
  }

  /* Панель фиксирована на всю страницу, включая hero и навигацию, где сортировать
     ещё нечего. Показываем её только рядом с гридом — та же идея, что у desktop
     CTA в initFilterJump, но через IntersectionObserver. */
  function initMobileActions(section) {
    if (section._collectionActionsCleanup) section._collectionActionsCleanup();

    var bar = section.querySelector('[data-collection-mobile-actions]');
    var grid = section.querySelector('[data-collection-product-grid]');
    if (!bar || !grid || typeof window.IntersectionObserver !== 'function') return;

    var TUCKED = 'collection-products-v1__mobile-actions--tucked';
    bar.classList.add(TUCKED);

    var observer = new window.IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle(TUCKED, !entry.isIntersecting);
        });
      },
      // Грид должен зайти в вьюпорт заметно, а не краем — иначе панель мигает.
      { rootMargin: '0px 0px -20% 0px' }
    );

    observer.observe(grid);

    section._collectionActionsCleanup = function () {
      observer.disconnect();
      bar.classList.remove(TUCKED);
      section._collectionActionsCleanup = null;
    };
  }

  function initCollectionProducts(section) {
    hydrateCustomInputs(section);
    renderCustomFilterChips(section);
    initComputedFilters(section);
    initFilterJump(section);
    initMobileActions(section);

    section.querySelectorAll('[data-collection-sort-form], [data-collection-mobile-sort-form]').forEach(
      preserveCustomParams
    );
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-collection-products]').forEach(initCollectionProducts);
    scope.querySelectorAll('[data-collection-description]').forEach(initDescription);
    scope.querySelectorAll('[data-collection-sort-form]').forEach(initSort);
    scope.querySelectorAll('[data-collection-filter-form]').forEach(initFilterForm);
    scope.querySelectorAll('[data-collection-sheet]').forEach(initSheet);
    scope.querySelectorAll('[data-collection-mobile-sort-form]').forEach(initMobileSort);
    initSheetTriggers(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (activeSheet && event.target.contains(activeSheet)) closeSheet(false);
    event.target.querySelectorAll('[data-collection-products]').forEach(function (section) {
      if (section._collectionComputedAbort) section._collectionComputedAbort.abort();
      if (section._collectionJumpCleanup) section._collectionJumpCleanup();
      if (section._collectionActionsCleanup) section._collectionActionsCleanup();
    });
  });
})();
